
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import PriceDisplay from '@/domains/jobs/components/JobCreate/PriceDisplay.vue'

@Component({
  components: { PriceDisplay }
})
export default class ExtractOptionInvolvementTile extends Vue {
  @Prop({ type: String, default: '' })
  label!: string
  
  @Prop({ type: String, default: '' })
  description!: string

  @Prop({ type: Number, default: null })
  price?: number

  @Prop({ type: Boolean })
  selected?: boolean

  get value(): boolean {
    return this.selected || false
  }

  set value(val: boolean) {
    this.$emit('update:selected', val)
  }
}
